import EmployeesSectionBottomContent from "./bottom-content";
import EmployeesSectionHeader from "./header";
import EmployeesSectionMidContent from "./mid-content";

const EmployeesSection = () => {
  return (
    <section className="px-8 py-16 md:px-0 md:py-24 bg-background-primary-dark-dark text-light">
      <div className="flex flex-col items-center space-y-8 md:space-y-16">
        <EmployeesSectionHeader />
        <EmployeesSectionMidContent />
        <EmployeesSectionBottomContent />
      </div>
    </section>
  );
};

export default EmployeesSection;
